import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=2f1d2b09&scoped=true&"
var script = {}
import style0 from "@/assets/css/wcms.css?vue&type=style&index=0&id=2f1d2b09&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1d2b09",
  null
  
)

export default component.exports